// more gettext functions in django/view/i18n.py

export function gettext(msgid) {
    if (!window.LOCALE || !window.LOCALE.catalog) {
        return msgid;
    }

    var value = window.LOCALE.catalog[msgid];
    if (typeof value == "undefined") {
        return msgid;
    } else {
        return typeof value == "string" ? value : value[0];
    }
}
